import { Cpu } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const GanModelIcon = DeckardIconWrapper({ Icon: Cpu });
